var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_16064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 141,
    height: 141
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.629 0.370605V139H0V0.370605H138.629V0.370605Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_16064)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.359 31.1809C104.709 32.4402 106.558 34.2886 107.817 36.6394C109.076 38.9904 109.746 41.324 109.746 47.7644V92.7901C109.746 95.9803 112.332 98.5663 115.523 98.5663C118.713 98.5663 121.299 95.9803 121.299 92.7901V47.3197C121.299 37.0207 120.224 33.2835 118.214 29.5174C116.245 25.7964 113.202 22.7535 109.481 20.7837C105.715 18.7736 101.977 17.6992 91.6783 17.6992H46.2079C43.0178 17.6992 40.4316 20.2854 40.4316 23.4755C40.4316 26.6655 43.0178 29.2517 46.2079 29.2517H91.2335C97.674 29.2517 100.008 29.9217 102.359 31.1809V31.1809ZM35.8409 40.8047C29.4005 40.8047 27.0668 41.4748 24.7159 42.7339C22.3903 43.9651 20.4885 45.8669 19.2574 48.1925C17.9982 50.5434 17.3281 52.877 17.3281 59.3175V103.159C17.3281 109.594 17.9982 111.933 19.2574 114.284C20.5166 116.635 22.365 118.483 24.7159 119.743C27.0669 121.002 29.4005 121.672 35.8409 121.672H79.6825C86.1172 121.672 88.4566 121.002 90.8074 119.743C93.1584 118.483 95.0068 116.635 96.266 114.284C97.5252 111.933 98.1952 109.6 98.1952 103.159V59.3175C98.1952 52.877 97.5252 50.5434 96.266 48.1925C95.0349 45.8669 93.1331 43.9651 90.8074 42.7339C88.4566 41.4748 86.123 40.8047 79.6825 40.8047H35.8409V40.8047Z",
    fill: "#5763F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4de7f69c153bf6799a221e60319531b9.svg";
export { ForwardRef as ReactComponent };